import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function DiscordCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
      navigate(`/meu-usuario?discord_code=${code}`, { replace: true });
    } else {
      navigate("/meu-usuario", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-muted-foreground">Vinculando Discord...</p>
    </div>
  );
}
